module.exports = __webpack_public_path__ + "img/hy_dzp.ca8e2488.svg";